const key = 'INVERTERS__';

exports.SET_INVERTER_EDIT_DATA = `${key}SET_INVERTER_EDIT_DATA`;
exports.SET_INVERTER_ID_TO_EDIT = `${key}SET_INVERTER_ID_TO_EDIT`;
exports.SET_GET_MODEL_INVERTERS = `${key}SET_GET_MODEL_INVERTERS`;
exports.SET_CREATE_EDIT_DEVICES = `${key}SET_CREATE_EDIT_DEVICES`;
exports.SET_IS_EDIT_DEFAULT = `${key}SET_IS_EDIT_DEFAULT`;
exports.SET_CREATE_EDIT_VALUES = `${key}SET_CREATE_EDIT_VALUES`;
exports.ADD_CREATE_EDIT_VALUES_GROUP_CONDITIONS = `${key}ADD_CREATE_EDIT_VALUES_GROUP_CONDITIONS`;
exports.REMOVE_CREATE_EDIT_VALUES_GROUP_CONDITIONS = `${key}REMOVE_CREATE_EDIT_VALUES_GROUP_CONDITIONS`;
exports.ADD_CREATE_EDIT_VALUES_OR_CONDITION = `${key}ADD_CREATE_EDIT_VALUES_OR_CONDITION`;
exports.REMOVE_CREATE_EDIT_VALUES_OR_CONDITION = `${key}REMOVE_CREATE_EDIT_VALUES_OR_CONDITION`;
exports.CHANGE_CREATE_EDIT_VALUES_OR_CONDITION = `${key}CHANGE_CREATE_EDIT_VALUES_OR_CONDITION`;

exports.ADD_CREATE_EDIT_VALUES_ACTION = `${key}ADD_CREATE_EDIT_VALUES_ACTION`;
exports.REMOVE_CREATE_EDIT_VALUES_ACTION = `${key}REMOVE_CREATE_EDIT_VALUES_ACTION`;
exports.CHANGE_CREATE_EDIT_VALUES_ACTION = `${key}CHANGE_CREATE_EDIT_VALUES_ACTION`;

exports.SET_ALARMS_LIST = `${key}SET_ALARMS_LIST`;
exports.START_DELETING_ALARM = `${key}START_DELETING_ALARM`;
exports.DELETE_ALARM = `${key}DELETE_ALARM`;
exports.ADD_ALARM = `${key}ADD_ALARM`;
exports.SET_ALARM_COUNT = `${key}SET_ALARM_COUNT`;
exports.EDIT_ALARM = `${key}EDIT_ALARM`;
exports.RESET_OFFSET = `${key}RESET_OFFSET`;
exports.SET_SEARCH = `${key}SET_SEARCH`;
exports.RESET_ALARMS = `${key}RESET_ALARMS`;
exports.SET_SABE_STATE = `${key}SET_SABE_STATE`;
